import Splide from '@splidejs/splide';

export function initializeSplideJS() {
  const splides = document.querySelectorAll('[data-action="splidejs"]');
  splides.forEach(element => new Splide(element as HTMLElement).mount());
}
